import 'bootstrap';
import '../stylesheets/search';
import { width } from './_function/detectDevice';
import scrLock from './_function/scrollLock';

$(function () {
  const clsOpen = 'accOpen';

  $('input[type="checkbox"].category').on('change', function () {
    // 自身に紐づく全ての小カテゴリの選択状態を、自身の選択状態に合わせる
    const checked = $(this).prop('checked');
    $(this).closest('.category-and-subcategories').find('input[type="checkbox"].subcategory').each(function () {
      $(this).prop('checked', checked);
    });
    exeSubmit($(this));
  });

  $('input[type="checkbox"].subcategory').on('change', function () {
    // 自身に紐づく大カテゴリについて、紐づく小カテゴリが全て選択されている場合は選択し、選択されていないものがある場合は選択を解除する
    const node = $(this).closest('.category-and-subcategories');
    const isAllCheckboxesChecked = $(node).find('input[type="checkbox"].subcategory:checked').length == $(node).find('input[type="checkbox"].subcategory').length;
    $(node).find('input[type="checkbox"].category').prop('checked', isAllCheckboxesChecked);
    exeSubmit($(this));
  });

  $('form.search-conditions input[type="checkbox"]').on('change', function () {
    exeSubmit($(this));
  });

  $('.condition-buttons .button').not('.all').on('click', function () {
    // 自身に紐づく検索条件項目を削除する
    $(this).find('input[type="hidden"]').prop('disabled', true);
    $(this).parents('form').trigger('submit');
  });

  function exeSubmit($this) {
    if (width() === 'pc') $this.parents('form').trigger('submit');
  }

  // 条件クリア
  $('.float .clear, .condition-buttons .clear').on('click', function(e) {
    e.preventDefault();
    $('form.search-conditions').find('input[type="checkbox"]').prop('checked', false);
    $('.toggle').addClass('collapsed').prop('aria-expanded', false);
    $('.subcategories').addClass('collapse').removeClass('show');
    $('.condition-buttons .button.all').addClass('on');
    $('.condition-buttons .button:not(.all)').removeClass('on')
      .find('input[type="hidden"]').prop('disabled', 'disabled');
    $('.condition-buttons .clearBtn').removeClass('on');
    $('.conditions section').each(function(i, e) {
      if (width() !== 'pc' && $(e).hasClass('accOpen')) {
        const wrap = $(e).find('.accCnt');
        adjH(wrap);
      }
    });
  });
  $('.float .clear').on('click', function(e) {
    e.preventDefault();
    $('.conditions section').each(function(i, e) {
      close($(e));
    });
  });
  $('.condition-buttons .clear').on('click', function(e) {
    e.preventDefault();
    $('form.search-conditions').trigger('submit');
  });

  // 送信（SP）
  $('.float .submit').on('click', function(e) {
    e.preventDefault();
    if (width() !== 'pc') $('form.search-conditions').trigger('submit');
  });

  $('.openCond').on('click', function(e) {
    e.preventDefault();
    $('.float').addClass('condOpen');
    $('.sidebar-contents.conditions').addClass('condOpen');
    $('.conditions section').each(function(i, e) {
      const wrap = $(e).find('.accCnt');
      if (width() !== 'pc') {
        if ($(e).hasClass('accOpen')) {
          adjH(wrap);
        }
      } else {
        wrap.css('height', '');
      }
    });
    scrLock();
  });
  $('.closeBtn').on('click', function(e) {
    e.preventDefault();
    $('.float').removeClass('condOpen');
    $('.sidebar-contents.conditions').removeClass('condOpen');
    if (!$('body').hasClass('navOpen')) scrLock(false);
  });

  // アコーディオン（検索条件、SPのみ）
  $(window).on('load', function() {
    $('.conditions section h2').append('<span class="accIcon"></span>');
    $('.conditions section > ul').wrap('<div class="accCnt"></div>');
    $('.conditions section').each(function(i, e) {
      const checked = $(e).find('input[type="checkbox"]:checked');
      if (checked.length > 0) open($(e));
    });
    $('.conditions section h2').each(function(i, e) {
      $(e).on('click', function () {
        const parent = $(this).closest('section');
        if (!parent.hasClass(clsOpen)) {
          open(parent);
        } else {
          close(parent);
        }
      });
    });
    $('.toggle').on('click', function () {
      const parent = $(this).closest('section');
      if (width() !== 'pc') {
        setTimeout(function() {
          if (parent.hasClass(clsOpen)) adjH(parent.find('.accCnt'));
        }, 300);
      }
    });
    $(window).on('resize', function() {
      $('.conditions section .accCnt').each(function(i, e) {
        const parent = $(this).closest('section');
        if (width() !== 'pc') {
          if (parent.hasClass(clsOpen)) adjH($(e));
        } else {
          const wrap = parent.find('.accCnt');
          wrap.css('height', '');
        }
      });
    });
  });
  function open(parent) {
    parent.addClass(clsOpen);
    const wrap = parent.find('.accCnt');
    adjH(wrap);
  }
  function close(parent) {
    parent.removeClass(clsOpen);
    const wrap = parent.find('.accCnt');
    wrap.css('height', '');
  }
  function adjH(wrap) {
    const cntH = wrap.find('> ul').outerHeight();
    wrap.css('height', cntH);
  }

  // 検索条件を企業ページに渡す
  const link = $('.stocks li a');
  const form = link.closest('form');
  link.each(function(i, e) {
    $(e).on('click', function(ev) {
      ev.preventDefault();
      const href = $(this).attr('href');
      form.attr('action', href);
      form.submit();
    });
  });

});
